import React from "react";
import { useTranslation } from "react-i18next";
import { LoadingOutlined } from "@ant-design/icons";

const ImagePreviewLoading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="row row-center">
      <LoadingOutlined style={{ fontSize: 28, position: "absolute" }} />
      <span className="text-center" style={{ fontSize: 18, marginTop: 40 }}>
        {t("generatingImagePreview")}
      </span>
    </div>
  );
};

export default ImagePreviewLoading;
